<template>
	<div class="review-box">
		<div class="img-box clearfix">
			<img src="/img/avatars/2.png" alt="" class="profile l" />
			<div class="text-box l">
				<div class="clearfix">
					<div class="name">
						{{
							review.names === 'undefined undefined'
								? 'Unknown'
								: review.names
						}}
					</div>
					<Rate
						class="rate"
						v-model="review.rating"
						:allow-half="true"
					/>
				</div>
			</div>
		</div>
		<div class="s-box clearfix">
			<div class="desc">{{ review.review }}</div>
		</div>
		<div class="desc-box">
			<div class="date">
				{{ moment(review.review_date).format('Do MM YYYY HH:mm') }}
			</div>
			<div class="use">12 People found this useful</div>
		</div>
		<div class="action-box clearfix">
			<!-- <div class="btn l">Comment</div> -->
			<div class="r-content">
				<div class="q-box l">
					<div class="question l">Was this review helpful?</div>
					<div class="answer l">
						<div class="btn-a positive tx-green l">
							<i class="fa fa-check"></i>
						</div>
						<div class="btn-a negative tx-red l">
							<i class="fa fa-times"></i>
						</div>
					</div>
				</div>
				<div class="circle l"></div>
				<div class="flag l">Flag this Review</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
		Rate: () => import('@/libs/clarks/components//rate/index'),
	},
	props: {
		review: {
			default: function () {
				return {};
			},
		},
	},
	data() {
		return {
			moment,
			utils,
		};
	},
};
</script>

<style lang="less">
@border: solid 1px #e4e5ec;

.review-box {
	padding: 10px 5px 25px 5px;
	margin: 25px 10px 0 10px;
	border-bottom: @border;
	width: 100%;

	.rate {
		font-size: 13px;
		margin: 0 0 0 20px;
	}
	.action-box {
		margin: 15px 0 0 0;

		.btn {
			background: #d0d2db;
			color: var(--white);
			padding: 7px 10px;
			border-radius: 2px;
		}
		.r-content {
			float: right;

			.circle {
				background: #e4e5ec;
				width: 5px;
				height: 5px;
				border-radius: 50%;
				margin: 10px 15px 0 0;
			}
			.question {
				margin: 2px 0 0 0;
			}
			.answer {
				border: @border;
				margin: 0 15px 0 30px;

				.btn-a {
					padding: 0 7px;
					cursor: pointer;

					.fa {
						font-size: 13px;
						width: 15px;
					}
				}
				.positive {
					border-right: @border;
				}
			}
			.flag {
				font-size: 12px;
				color: var(--text-grey);
			}
		}
	}
	.desc {
		font-size: 13px;
		margin: 20px 0 12px 0;
	}

	.desc-box {
		.date {
			text-align: right;
			font-size: 13px;
			color: var(--text-grey);
		}
		.use {
			color: var(--text-grey);
			font-size: 12px;
		}
	}
	.s-box {
		.title {
			font-family: var(--font-bold);
			margin: -5px 0 0 10px;
		}
		.rating {
			background: var(--ne-red);
			margin: -5px 10px 0 10px;
			padding: 0 8px;
			color: var(--white);
		}
	}
	.stars {
		margin: 15px 0 0 0;

		.active,
		.inactive {
			font-size: 20px;
		}
		label {
			font-size: 18px;
		}
	}
	.l {
		float: left;
	}
	.profile {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		float: left;
	}
	.name {
		color: var(--text-color);
		margin: 5px 0 0 20px;
		font-weight: 600;
		font-size: 13px;
	}
}
</style>
